import { render, staticRenderFns } from "./ProductItemRow.vue?vue&type=template&id=ba6422f2&scoped=true&"
import script from "./ProductItemRow.vue?vue&type=script&lang=js&"
export * from "./ProductItemRow.vue?vue&type=script&lang=js&"
import style0 from "./ProductItemRow.vue?vue&type=style&index=0&id=ba6422f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba6422f2",
  null
  
)

/* custom blocks */
import block0 from "./ProductItemRow.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VChip,VIcon,VListItemAction,VRow,VTooltip})
